import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
// import FindModuleById from '.././FindModuleById';
import { base_url, Apitoken, Authtoken } from "../Global";
import { MaterialReactTable } from 'material-react-table';
import PropTypes from 'prop-types';

const ProductionDashboardDailyReport = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [value, setValue] = useState({});
  const [valuerawmaterials, setValuerawmaterials] = useState([]);
  const [valuequantityprocessed, setValuequantityprocessed] = useState([]);
  const [valuegradea, setValuegradea] = useState([]);
  const [valuegradeb, setValuegradeb] = useState([]);
  const [valuepuree, setValuepuree] = useState([]);
  const [valuecrumble, setValuecrumble] = useState([]);
  const [valuesemifinished, setValuesemifinished] = useState([]);

  useEffect(() => {

    axios
      .get(`/production-dasboard/daily-report-details/${id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          setValue(response.data.data.daily_reports);
          setValuerawmaterials(response.data.data.daily_reports.bl_net_weight_data);
          setValuequantityprocessed(response.data.data.daily_reports.quantity_processed_data);
          setValuegradea(response.data.data.daily_reports.grade_a_data);
          setValuegradeb(response.data.data.daily_reports.grade_b_data);
          setValuepuree(response.data.data.daily_reports.puree_data);
          setValuecrumble(response.data.data.daily_reports.crumble_data);

          setValuesemifinished(response.data.data.daily_reports.semi_finished_data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  const handleDownload = async () => {
    //let season_id = localStorage.getItem("season_id");
    window.open(`${base_url}/production-dasboard/daily-report-details-excel-export/${id}`, '_blank');

  };


  // BarcodeNumberCell Component
  const BarcodeNumberCell = ({ row }) => (
    <a href={`/production-output-view/${row.original.id}`}>
      {row.original.barcode_number}
    </a>
  );




  // ✅ PropTypes validation
  BarcodeNumberCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        barcode_number: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  };
  const columnsother = [
    {
      header: 'Barcode Number',
      accessorFn: (row) => row.barcode_number,
      Cell: BarcodeNumberCell,
    },
    {
      accessorKey: "toal_lot_number",
      header: "Lot Number",
    },

    {
      accessorKey: 'prodcut_name', //normal accessorKey
      header: 'Product',
    },

    {
      accessorKey: 'total_output_type', //normal accessorKey
      header: 'Output Type',
    },


    { accessorKey: 'date_time', header: 'Date Time' },
    { accessorKey: 'shift', header: 'Shift' },
    { accessorKey: 'shift_date', header: 'Shift Date' },

    {
      header: 'Net Weight',
      accessorFn: (row) => {
        const netWeight = row.total_net_weight ?? 0; // Default to 0 if undefined or null
        return `${Number(netWeight).toFixed(2)} (KG)`;
      },
    },
    {
      accessorKey: 'total_number_of_boxes', //normal accessorKey
      header: 'Number Of Boxes',
    },
    {
      accessorKey: 'packaging_name', //normal accessorKey
      header: 'Package Type',
    },
    {
      header: 'Location',
      accessorFn: (row) =>
        row.location_name
          ? `${row.location_name.title} `
          : '',
    },

    {
      header: 'Created By',
      accessorFn: (row) =>
        row.createdby
          ? `${row.createdby.first_name} ${row.createdby.last_name}`
          : '',
    },
    {
      header: 'Updated By',
      accessorFn: (row) =>
        row.updatedby
          ? `${row.updatedby.first_name} ${row.updatedby.last_name}`
          : '',
    },
  ];



  // ✅ Define Columns
  const columns = [
    {
      header: 'Location',
      accessorFn: (row) => `${(row.location_name) ? row.location_name.title : ""} `,
    },
    {
      header: 'Product',
      accessorFn: (row) => `${(row.product_detail) ? row.product_detail.name : ""} `,
    },
    {
      accessorKey: 'product_type',
      header: 'Product Type',
    },
    {
      accessorKey: 'shift_date',
      header: 'Shift Date',
    },
    {
      accessorKey: 'shift',
      header: 'Shift',
    },
    {
      header: 'Quantity Processed',
      accessorFn: row =>
        row.quantity_processed != null
          ? `${row.quantity_processed.toFixed(2)} (KG)`
          : '',
    },
    {
      header: 'Created By',
      accessorFn: (row) =>
        row.createdby ? `${row.createdby.first_name} ${row.createdby.last_name}`.trim() : '',
    },
    {
      header: 'Updated By',
      accessorFn: (row) =>
        row.updatedby ? `${row.updatedby.first_name} ${row.updatedby.last_name}`.trim() : '',
    },
  ];



  // BarcodeNumberCell Component
  const DetailsCell = ({ row }) => (
    <a href={`/production-output-view/${row.original.id}`}>
      {row.original.lot_number}
    </a>
  );

  // ✅ PropTypes validation
  DetailsCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        lot_number: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  };
  const columns_raw_material = [
    {
      header: 'Lot Number',
      accessorFn: (row) => `${row.lot_number}`,
      Cell: DetailsCell,
    },
    {
      accessorKey: 'date_time',
      header: 'Date Time',
    },
    {
      header: 'Supplier',
      accessorFn: (row) => `${row.supplier_name ? row.supplier_name.name : ''}`,
    },
    {
      accessorKey: 'plate_number',
      header: 'Plate Number',
    },

    {
      header: 'BL Net Weight',
      accessorFn: (row) => {
        const netWeight = row.net_weight ?? 0; // Default to 0 if undefined or null
        return `${Number(netWeight).toFixed(2)} (KG)`;
      },
    },
    {
      header: 'Net Weight',
      accessorFn: (row) => {
        const netWeight = row.total_net_weight ?? 0; // Default to 0 if undefined or null
        return `${Number(netWeight).toFixed(2)} (KG)`;
      },
    },
    {
      header: 'Grade A Net Weight',
      accessorFn: (row) => {
        let grade_a_net_weight = 0;
        if (row.id > 357) {
          grade_a_net_weight = row.grade_a_bl_weight;
        } else {
          grade_a_net_weight = row.grade_a_net_weight;
        }
        const netWeight = grade_a_net_weight ?? 0; // Default to 0 if undefined or null
        return `${Number(netWeight).toFixed(2)} (KG)`;
      },
    },
    {
      header: 'Grade B Net Weight',
      accessorFn: (row) => {
        let grade_b_net_weight = 0;
        if (row.id > 357) {
          grade_b_net_weight = row.grade_b_bl_weight;
        } else {
          grade_b_net_weight = row.grade_b_net_weight;
        }

        const netWeight = grade_b_net_weight ?? 0; // Default to 0 if undefined or null
        return `${Number(netWeight).toFixed(2)} (KG)`;
      },
    },
    // {
    //   header: 'Weight Difference',
    //   Cell: WeightDifferenceCell,
    // },
    {
      header: 'Weight Difference',
      accessorFn: (row) => {
        const netWeight = row.difference ?? 0; // Default to 0 if undefined or null
        return `${Number(netWeight).toFixed(2)} (KG)`;
      },
    },

    {
      header: 'Created By',
      accessorFn: (row) =>
        `${row.createdby ? row.createdby.first_name + ' ' + row.createdby.last_name : ''}`,
    },
    {
      header: 'Updated By',
      accessorFn: (row) =>
        `${row.updatedby ? row.updatedby.first_name + ' ' + row.updatedby.last_name : ''}`,
    },
  ];


  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Production Dashbaord Daily Report</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/production-dasboard">Production Dashbaord Daily Report</Link>
                    </li>
                    <li className="breadcrumb-item active">
                      View Production Dashbaord Daily Report
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">  View Production Dashbaord Daily Report</h4>
                    <div style={{ float: "right" }}>

                      <button onClick={() => handleDownload()} className="btn btn-primary me-1"  > Download Daily  <i className="fa fa-print" />  </button>
                    </div>
                    <table className="table table-bordered">
                      <tr>
                        <th className="p-3">Shift Date</th>
                        <td className="p-3">{value.shift_date}</td>
                      </tr>
                      <tr>
                        <th className="p-3">Location</th>
                        <td className="p-3">{value.location_name}</td>
                      </tr>
                      <tr>
                        <th className="p-3">Shift</th>
                        <td className="p-3">{value.shift}</td>
                      </tr>
                      <tr>
                        <th className="p-3">Total reception ( Bl Net Weight)</th>
                        <td className="p-3">{Number(value.bl_net_weight).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                      </tr>
                      <tr>
                        <th className="p-3">Total Consumption</th>
                        <td className="p-3">{Number(value.quantity_processed).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                      </tr>
                      <tr>
                        <th className="p-3">Finished Grade A</th>
                        <td className="p-3">{Number(value.grade_a).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                      </tr>
                      <tr>
                        <th className="p-3">Finished Grade B</th>
                        <td className="p-3">{Number(value.grade_b).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                      </tr>
                      <tr>
                        <th className="p-3">Finished Crumble</th>
                        <td className="p-3">{Number(value.crumble).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                      </tr>
                      <tr>
                        <th className="p-3">Finished Puree</th>
                        <td className="p-3">{Number(value.puree).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                      </tr>

                      <tr>
                        <th className="p-3">Semi Finished</th>
                        <td className="p-3">{Number(value.semi_finished).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                      </tr>



                    </table>


                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <section className="comp-section">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="card bg-white">
                        <div className="card-body">
                          <ul className="nav nav-tabs nav-tabs-bottom">
                            <li className="nav-item">
                              <a className="nav-link active" href="#bottom-tab0" data-bs-toggle="tab">Total reception ( Bl Net Weight) </a>
                            </li>
                            <li className="nav-item">
                              <a className="nav-link" href="#bottom-tab1" data-bs-toggle="tab">Total Consumption </a>
                            </li>
                            <li className="nav-item">
                              <a className="nav-link" href="#bottom-tab2" data-bs-toggle="tab">Grade A </a>
                            </li>
                            <li className="nav-item">
                              <a className="nav-link" href="#bottom-tab3" data-bs-toggle="tab">Grade B</a>
                            </li>

                            <li className="nav-item">
                              <a className="nav-link" href="#bottom-tab41" data-bs-toggle="tab">Crumble</a>
                            </li>
                            <li className="nav-item">
                              <a className="nav-link" href="#bottom-tab4" data-bs-toggle="tab">Puree</a>
                            </li>
                            <li className="nav-item">
                              <a className="nav-link" href="#bottom-tab5" data-bs-toggle="tab">Semi Finished</a>
                            </li>
                          </ul>
                          <div className="tab-content">
                            <div className="tab-pane show active" id="bottom-tab0">
                              <div className="row" id="listing-followup">
                                <div className="col-sm-12">
                                  <div className="card card-table">
                                    <div className="card-body">
                                      <div className="table-responsive">
                                        <h5 className="p-3">Total reception ( Bl Net Weight)</h5><hr />
                                        <MaterialReactTable
                                          columns={columns_raw_material}
                                          data={valuerawmaterials}
                                          enableColumnOrdering
                                          enablePinning

                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="tab-pane" id="bottom-tab1">
                              <div className="row" id="listing-followup-groupby">
                                <div className="col-sm-12">
                                  <div className="card card-table">
                                    <div className="card-body">
                                      <h5 className="p-3">Total Consumption</h5><hr />
                                      <div className="table-responsive">
                                        <MaterialReactTable columns={columns}
                                          data={valuequantityprocessed}
                                          enableColumnOrdering
                                          enablePinning
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="tab-pane" id="bottom-tab2">
                              <div className="row" id="listing-followup-groupby">
                                <div className="col-sm-12">
                                  <div className="card card-table">
                                    <div className="card-body">
                                      <h5 className="p-3">Grade A</h5><hr />
                                      <div className="table-responsive">
                                        <MaterialReactTable columns={columnsother} data={valuegradea}
                                          enableColumnOrdering
                                          enablePinning
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="tab-pane" id="bottom-tab3">
                              <div className="row" id="listing-followup-groupby">
                                <div className="col-sm-12">
                                  <div className="card card-table">
                                    <div className="card-body">
                                      <h5 className="p-3">Grade B</h5><hr />

                                      <div className="table-responsive">

                                        <MaterialReactTable columns={columnsother} data={valuegradeb}
                                          enableColumnOrdering
                                          enablePinning
                                        />


                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="tab-pane" id="bottom-tab41">
                              <div className="row" id="listing-followup-groupby">
                                <div className="col-sm-12">
                                  <div className="card card-table">
                                    <div className="card-body">
                                      <h5 className="p-3">Crumble</h5><hr />
                                      <div className="table-responsive">

                                        <MaterialReactTable columns={columnsother} data={valuecrumble}
                                          enableColumnOrdering
                                          enablePinning
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="tab-pane" id="bottom-tab4">
                              <div className="row" id="listing-followup-groupby">
                                <div className="col-sm-12">
                                  <div className="card card-table">
                                    <div className="card-body">
                                      <h5 className="p-3">Puree</h5><hr />
                                      <div className="table-responsive">

                                        <MaterialReactTable columns={columnsother} data={valuepuree}
                                          enableColumnOrdering
                                          enablePinning
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>


                            <div className="tab-pane" id="bottom-tab5">
                              <div className="row" id="listing-followup-groupby">
                                <div className="col-sm-12">
                                  <div className="card card-table">
                                    <div className="card-body">
                                      <h5 className="p-3">Semi Finished</h5><hr />
                                      <div className="table-responsive">
                                        <MaterialReactTable columns={columnsother} data={valuesemifinished}
                                          enableColumnOrdering
                                          enablePinning
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ProductionDashboardDailyReport;
